/** Default Lineage Journey profiles when a team member has no link in Prismic */
export const LINEAGE_TEAM_SOCIAL_URLS = {
  facebook: 'https://www.facebook.com/lineagejourney/',
  instagram: 'https://www.instagram.com/lineagejourney/',
  twitter: 'https://twitter.com/lineagejourney',
  email: 'info@lineagejourney.com',
};

export const resolveTeamSocialUrl = (value, fallback) => {
  const trimmed = String(value || '').trim();
  if (!trimmed) return fallback;
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;
  if (trimmed.startsWith('www.')) return `https://${trimmed}`;
  return `https://${trimmed}`;
};

export const resolveTeamEmail = (value) => {
  const trimmed = String(value || '').trim();
  return trimmed || LINEAGE_TEAM_SOCIAL_URLS.email;
};
